import PropTypes from "prop-types"
import { CheckOutlined, CloseOutlined } from "@ant-design/icons"
import { Flex } from "antd"
import styles from "./ActionQueue.module.css"

const Toast = ({ toasts, onUndo, onDismiss }) => {
  if (toasts.length === 0) return null
  return (
    <div className={styles.toastStack}>
      {toasts.map((toast) => (
        <Flex key={toast.id} align="center" gap={12} className={styles.toast}>
          <CheckOutlined className={styles.toastCheck} />
          <Flex vertical flex={1} style={{ minWidth: 0 }}>
            <div className={styles.toastTitle}>{toast.name} checked in.</div>
            <div className={styles.toastSubtitle}>{toast.subtitle}</div>
          </Flex>
          <button type="button" className={styles.toastUndo} onClick={() => onUndo(toast.id)}>
            Undo
          </button>
          <button type="button" className={styles.toastClose} onClick={() => onDismiss(toast.id)}>
            <CloseOutlined />
          </button>
        </Flex>
      ))}
    </div>
  )
}

Toast.propTypes = {
  toasts: PropTypes.array.isRequired,
  onUndo: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired
}

export default Toast
